import React from 'react';
import LazyImage from './LazyImage';

const Loading2 = () => {
    return (
        <div className='absolute top-0 left-0 z-20 w-full h-full flex items-center justify-center blurBack rounded-3xl '>
            <div className=' flex items-center justify-center mb-5  mt-5 rounded-3xl '>
                <div className='h-fit w-fit  flex flex-col items-center justify-center mb-5  mt-5 rounded-3xl '>
                    <LazyImage classNameImg='m-auto w-1/4 rounded-lg' src="/img/loader2.gif" alt="loading..." />
                </div>
            </div>
        </div>
    );
}

export default Loading2;
